module.exports = {
    API_IMG_TITLE:'"Able2Shine – A Softskills Educational Platform"', //项目名称
    // domainName:"https://api.able2shine.com/", //域名
    domainName:"https://api.able2shine.cn/", //域名
    interfacePrefix:"admin.php/", //接口前缀
    port:8001, //本地端口
    assetsPublicPath:"/", //打包后服务器文件路径
    
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 3